import Footer from "../components/Footer";

const Contact = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Contact Us</h1>
      <p className="mb-6">
        We’re here to help! If you have any questions, feedback, or require
        support regarding your Bill-lex account or features, feel free to reach
        out to us.
      </p>

      <div className="bg-gray-100 p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold mb-4">Email</h2>
        <p className="mb-4">
          You can reach us anytime at{" "}
          <a
            href="mailto:billlex.owner@gmail.com"
            className="text-blue-600 underline"
          >
            billlex.owner@gmail.com
          </a>
        </p>

        <h2 className="text-xl font-semibold mb-4">Business Hours</h2>
        <p className="mb-4">Monday – Saturday: 10:00 AM – 7:00 PM IST</p>

        <h2 className="text-xl font-semibold mb-4">Company Information</h2>
        <p>
          <strong>Bill-lex.com</strong> is a product of{" "}
          <strong>Lexora Technologies OPC Private Limited</strong>.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
